






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

import {
  ProductType,
  ProductCategory
} from '@cms-labs/typescript-api/products/types'

interface Navitem {
  text: string | undefined;
  href: string | undefined;
}

@Component({ components: { BBreadcrumb, BBreadcrumbItem } })
export default class BreadCrumb extends Vue {
  @Prop({ required: true })
  public productType!: ProductType

  @Prop({ required: false, default: null })
  public productCategory!: ProductCategory | undefined | null

  @Prop({ required: false, default: null })
  public productName!: string | undefined | null
}
